<template>
  <div ref="pres" class="presentation-container">
    <audio ref="presenterAudioElem" autoplay="true" playsInline="true" controls="false" style="display: none" />
    <div class="presentation" :style="'height: ' + calculateHeight() + ';'">
      <!-- <video
        ref="presentationElem"
        autoPlay="false"
        playsInline="true"
        muted="true"
      /> -->
      <div ref="videoWrapperElem" class="video-wrapper">
        <video
          ref="presentationElem"
          :style="'max-height: ' + calculateHeight() + ';'"
          autoPlay="false"
          playsInline="true"
          muted="true"
        />
        <div v-if="!isFullscreen & testDataChannelOk" class="fullscreen-icon" @click="goPresentationFullscreen">
          <a href="#" onclick="event.preventDefault()">
            <b-icon icon="fullscreen"></b-icon>
          </a>
        </div>
        <div v-if="isFullscreen" class="fullscreen-exit-icon" @click="exitPresentationFullscreen">
          <a href="#" onclick="event.preventDefault()">
            <b-icon icon="fullscreen-exit"></b-icon>
          </a>
        </div>
      </div>
    </div>

    <div ref="hostUsersContainer" class="presentation-users">
      <div
        v-for="peer in hostPeers"
        :key="peer.id"
        class="remote-user presentation-user"
        :class="[activeSpeaker.id === peer.id ? 'active' : '']"
      >
        <div class="remote-user-aspect-helper">
          <HostVideo
            v-if="Object.keys(peer.videoConsumer).length !== 0 && peer.role === 'host' && !peer.vidPaused"
            :peer="peer"
            :width="width"
            :current-user-count="10"
            class="remote-user-inner"
          />
          <HostNoVideo
            v-else-if="peer.role === 'host'"
            :peer="peer"
            :width="width"
            :current-user-count="10"
            class="remote-user-inner"
          />
        </div>
      </div>
      <!-- test users -->
      <div v-for="number in testuser" :key="number" class="remote-user presentation-user">
        <div class="remote-user-aspect-helper">
          <img class="remote-user-inner" src="https://picsum.photos/1920/1080" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Shows the presentation layout
 * @displayName Presentation
 */
import { mapState } from "vuex";
import HostVideo from "./HostVideo.vue";
import HostNoVideo from "./HostNoVideo.vue";

export default {
  name: "Presentation",
  components: {
    HostVideo,
    HostNoVideo,
  },
  props: {},
  data() {
    return {
      width: "360px",
      testuser: 0,
      presenter: undefined,
      presHeight: 0,
      presWidth: 0,
      remotePresentaion: true,
      timer: null,
      isFullscreen: false,
    };
  },
  computed: {
    ...mapState({
      testDataChannelOk: (state) => state.mediasoup.testDataChannelOk,
      isPresentation: (state) => state.mediasoup.isPresentation,
      displayName: (state) => state.mediasoup.displayName,
      peers: (state) => state.mediasoup.peers,
      currentPresentator: (state) => state.mediasoup.currentPresentator,
      mediasoupId: (state) => state.mediasoup.mediasoupId,
      activeSpeaker: (state) => state.mediasoup.activeSpeaker,
      presenterConsumerReady: (state) => state.mediasoup.presenterConsumerReady,
      presentationVolume: (state) => state.mediasoup.presentationVolume,
    }),

    // presenterConsumerReady() {
    //   let presenter = this.peers.find(x => x.id === this.currentPresentator);
    //   if (
    //     presenter &&
    //     !presenter.screenConsumer?._paused &&
    //     this.remotePresentaion
    //   ) {
    //     console.log("presndertready true");
    //     // this.startRemotePresentation();
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    hostPeers() {
      let hostpeers = this.peers.filter((peer) => peer.role === "host");
      console.log("hostpeers", hostpeers);
      return hostpeers;
    },
  },
  watch: {
    presenterConsumerReady(val) {
      console.log("presenterConsumerreadyval", val);
    },
    presentationVolume(newVal) {
      if (newVal) {
        if (newVal < 5) {
          this.$refs.presenterAudioElem.volume = 0;
        } else {
          this.$refs.presenterAudioElem.volume = newVal / 100;
        }
      }
    },
  },
  mounted() {
    // Detecting Esc button full screen exit
    document.addEventListener("fullscreenchange", this.escBtnFullscreenExited);
    this.getPresMeasurements();
    const stream = new MediaStream();
    console.log("PRESENTATION");
    let videoProducer;
    if (this.mediasoupId === this.currentPresentator) {
      videoProducer = this.$store.getters["mediasoup/screenProducer"];
      console.log("videoProdcuer self", videoProducer);
      stream.addTrack(videoProducer.track);
      this.$nextTick(function () {
        console.log("nextTickFkt", stream);
        this.$refs.presentationElem.srcObject = stream;
        this.$refs.presentationElem.play().catch((error) => console.log("videoElem.play() failed:%o", error));
      });
    } else {
      console.log("otherPresentator");
      // setTimeout(() => {
      //   this.startRemotePresentation();
      // }, 5000);

      this.timer = setInterval(() => {
        const presenterTrack = this.$store.getters["mediasoup/presenterConsumerReady"];
        if (presenterTrack?.muted === false) {
          console.log("presenterConsumerReady", presenterTrack);
          this.startRemotePresentation(presenterTrack);
        }
        // Handling screen share audio playback
        const presenterAudioTrack = this.$store.getters["mediasoup/getPresenterAudioConsumer"];
        console.log("Screen audio track", presenterAudioTrack);
        if (presenterAudioTrack?.muted === false) {
          const audioStream = new MediaStream();
          audioStream.addTrack(presenterAudioTrack);
          this.$nextTick(function () {
            console.log("nextTick audio stream", audioStream);
            this.$refs.presenterAudioElem.srcObject = audioStream;
            this.$refs.presenterAudioElem.play().catch((error) => console.log("audioElem.play() failed:%o", error));
          });
        }
      }, 200);
      // this.startRemotePresentation();
    }
    this.activateDragScroll();
  },
  unmounted() {
    console.log("presentation.vue unmounted");
    this.$refs.presentationElem.srcObject = "";
  },
  methods: {
    goPresentationFullscreen() {
      if (this.$refs.videoWrapperElem) {
        try {
          this.$refs.videoWrapperElem.requestFullscreen();
        } catch (error) {
          console.error("File: Presentation.vue, Fullscreen error", error);
        }
      }
    },
    exitPresentationFullscreen() {
      if (this.$refs.videoWrapperElem) {
        try {
          document.exitFullscreen();
        } catch (error) {
          console.error("File: Presentation.vue, Fullscreen error", error);
        }
      }
    },
    escBtnFullscreenExited() {
      this.isFullscreen = !this.isFullscreen;
    },
    /**
     * Assign the screen consumer of another presenter to the presentation tile
     * @public
     */
    startRemotePresentation(presenterTrack) {
      clearInterval(this.timer);
      this.remotePresentaion = false;
      if (this.mediasoupId !== this.currentPresentator) {
        console.log("startRemotePresentation", presenterTrack);
        // let presenter = this.peers.find(x => x.id === this.currentPresentator);

        const stream = new MediaStream();
        stream.addTrack(presenterTrack);

        console.log("nextTickFktprseenterconsumerready", stream);
        this.$refs.presentationElem.srcObject = stream;
        this.$refs.presentationElem.play().catch((error) => console.log("videoElem.play() failed:%o", error));
        // this.$nextTick(function() {
        // });
      }
    },
    randomColor() {
      const r = () => Math.floor(256 * Math.random());

      return `rgb(${r()}, ${r()}, ${r()})`;
    },
    // calculateWidth(){

    //     const currentUserCount = this.$store.getters['mediasoup/getHostsCount'] + this.testuser
    //     const cols = Math.ceil(Math.sqrt(currentUserCount))
    //     const width = 100/(cols)

    //     return `${width}%`
    // },
    calculateHeight() {
      // return correct value
      return `${this.presHeight - 148}px`;
    },
    getPresMeasurements() {
      if (this.$refs.pres) {
        this.$data.presHeight = this.$refs.pres.clientHeight;
        this.$data.presWidth = this.$refs.pres.clientWidth;
      } else {
        this.$data.presHeight = -1;
        this.$data.presWidth = -1;
      }
    },
    // Drag scroll
    activateDragScroll() {
      const slider = this.$refs.hostUsersContainer;
      let isDown = false;
      let startX;
      let scrollLeft;

      slider.addEventListener("mousedown", (e) => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active");
      });
      slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("active");
      });
      slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = x - startX;
        slider.scrollLeft = scrollLeft - walk;
      });
    },
  },
};
</script>
<style scoped>
.presentation-container {
  flex-direction: column;
}
.presentation-users {
  flex-shrink: 0;
  display: flex;
  width: 100%;
  height: auto;
  overflow-x: scroll;
  overflow-y: hidden;
  position: relative;
  justify-content: flex-start;
  align-content: center;
  flex-direction: row;
  margin: 0 -2px;
  cursor: pointer;
}
.presentation-users::-webkit-scrollbar {
  display: none;
}
.presentation-user {
  min-width: 250px;
  max-width: 250px;
}
.presentation {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 860px;
  margin-bottom: 10px;
}
.presentation > video {
  width: auto;
  max-height: 100%;
}
.video-wrapper {
  position: relative;
}
/* .video-wrapper > video {
  position: absolute;
} */
.fullscreen-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 5px;
}
.fullscreen-exit-icon {
  position: absolute;
  bottom: 5px;
  right: 5px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 3px;
}

/* scrollbar */
::-webkit-scrollbar {
  width: 2px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}
</style>
